var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-item",style:({width:_vm.cardWidth})},[_c('div',{staticClass:"head"},[_vm._v("\n        "+_vm._s(_vm.head)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }